// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Utils = require("./utils");
var ReasonReact = require("reason-react/src/ReasonReact.js");

function get_touch_position(touches) {
  var touch = Utils.$$TouchList[/* hd */0](touches);
  return /* record */[
          /* x */touch.screenX,
          /* y */touch.screenY,
          /* timestamp */Date.now()
        ];
}

var component = ReasonReact.statelessComponent("SwipeZone");

var touchRecorder = /* record */[
  /* touchStart : record */[
    /* x */0.0,
    /* y */0.0,
    /* timestamp */0.0
  ],
  /* touchEnd : record */[
    /* x */0.0,
    /* y */0.0,
    /* timestamp */0.0
  ]
];

function get_swipe_direction(param) {
  var touchStart = param[/* touchStart */0];
  var touchEnd = param[/* touchEnd */1];
  var time_delta = touchEnd[/* timestamp */2] - touchStart[/* timestamp */2];
  var get_swipe_speed = function (a, b) {
    return (a - b) * 10000.0 / time_delta;
  };
  var y_speed = get_swipe_speed(touchEnd[/* y */1], touchStart[/* y */1]);
  var x_speed = get_swipe_speed(touchEnd[/* x */0], touchStart[/* x */0]);
  var match = Math.abs(y_speed) > Math.abs(x_speed);
  if (match) {
    if (y_speed - 4000.0 > 0.0) {
      return /* Down */3;
    } else if (y_speed + 4000.0 < 0.0) {
      return /* Up */2;
    } else {
      return undefined;
    }
  } else if (x_speed - 4000.0 > 0.0) {
    return /* Right */1;
  } else if (x_speed + 4000.0 < 0.0) {
    return /* Left */0;
  } else {
    return undefined;
  }
}

function make(onSwipe, children) {
  var on_touch_start = function ($$event) {
    touchRecorder[/* touchStart */0] = get_touch_position($$event.targetTouches);
    return /* () */0;
  };
  var on_touch_end = function ($$event) {
    $$event.preventDefault();
    touchRecorder[/* touchEnd */1] = get_touch_position($$event.changedTouches);
    var match = get_swipe_direction(touchRecorder);
    if (match !== undefined) {
      return Curry._1(onSwipe, match);
    } else {
      return /* () */0;
    }
  };
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (_self) {
              return ReasonReact.createDomElement("div", {
                          onTouchStart: on_touch_start,
                          onTouchEnd: on_touch_end
                        }, children);
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.get_touch_position = get_touch_position;
exports.component = component;
exports.touchRecorder = touchRecorder;
exports.get_swipe_direction = get_swipe_direction;
exports.make = make;
/* component Not a pure module */
